import React from 'react';
import {
  SPLIT_SEPARATORS,
  Action,
  CopyToClipboard,
  withInject,
} from '@piwikpro/platform';
import {
  Stack,
  Text,
  withTranslation,
} from '@piwikpro/ui-components';
import { FormValidator } from '@piwikpro/form-crate';
import { TrackerSettings } from '../../../TrackerSettings';

export interface ExcludedIpsProps {
  appId: string
  trackerSettings: TrackerSettings
  globalAndAppTrackerSettings: Array<string | object>
  appTrackerSettings: string[]
  validation: FormValidator
  t: (key: string) => string
}

interface FormValues {
  [key: string]: string[]
}

class ExcludedIps extends React.Component<ExcludedIpsProps> {
  constructor(props: ExcludedIpsProps) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(values: FormValues, {
    setErrors,
    setSubmitting,
    setFieldValue,
  }: {
    setErrors: Function
    setSubmitting: Function
    setFieldValue: Function
  }) {
    const {
      trackerSettings,
      appId,
      globalAndAppTrackerSettings,
    } = this.props;
    const field = Object.keys(values)[0];
    const valuesWithoutGlobals = {
      [field]: values[field].filter((element: any) => !element.disabled),
    };

    try {
      await trackerSettings.updateSettingsForApp(appId, valuesWithoutGlobals);
    } catch (err: any) {
      setErrors(err.errors);
      setFieldValue(
        field,
        globalAndAppTrackerSettings,
        false,
      );
    }

    setSubmitting(false);
  }

  render() {
    const {
      appTrackerSettings,
      globalAndAppTrackerSettings,
      validation,
      t,
    } = this.props;

    return (
      <>
        <Text as="h2" size={20} weight={700} wrapType="noWrapAndCutText" dataId="Header.medium">{t('apps.details.settings.blacklisting.exclude-ips.title')}</Text>
        <Stack vertical spacing="narrow" horizontalAlignment="fill">
          <Stack.Item>
            <Action.AutoSavedTagsInputControl
              id="app-settings-blacklisting-ips"
              label="&nbsp;"
              info={t('apps.details.settings.blacklisting.exclude-ips.help')}
              name="excluded_ips"
              initialValue={globalAndAppTrackerSettings}
              validationSchema={validation.createValidationSchema(validators => ({
                excluded_ips: validators.trackerSettings.excludedIps,
              }))}
              splitSeparators={SPLIT_SEPARATORS}
              onSubmit={this.handleSubmit}
            />
          </Stack.Item>
          <Stack.Item>
            <CopyToClipboard text={appTrackerSettings.join('\n')} />
          </Stack.Item>
        </Stack>
      </>
    );
  }
}

export default withInject({
  trackerSettings: 'TrackerSettingsCrate.tracker',
  validation: 'FormCrate.validation',
})(
  withTranslation(['administration'])(ExcludedIps as any),
);
